import React, { Component } from "react";
import "./SubscriptionPage.scss";
import { connect } from "react-redux";
import { fetchPackageDetails, getStripeURL } from "../../actions/subscriptionAction";
import { ReactComponent as SuccessIcon } from "../SubscriptionModule/BillingComponents/payment-successful.svg";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

class SubscriptionPageSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        sessionStorage.setItem("getStarted", true);
        setTimeout(() => {
            this.props.history.push("/home");
        }, 2000);
    }

    render() {
        return (
            <div className="subscription-page subscription-success">
                <SuccessIcon />
                <p>Subscription successful</p>
                {/* {this.props.packageObj.is_trial_used ? <p>Subscription successful</p> : <p>Trial setup successful</p>} */}
                <div className="loader-container">
                    <Dimmer inverted active>
                        <Loader size="big" content="Redirecting" />
                    </Dimmer>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state.subscriptionReducer.packages,
    packageObj: state.globalReducer.packageObj,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageDetails: () => dispatch(fetchPackageDetails()),
    getStripeURL: (data) => dispatch(getStripeURL(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPageSuccess);
